"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.beautyStoreQuery = void 0;
var _fetching = require("@ori/fetching");
const beautyStoreQuery = exports.beautyStoreQuery = (0, _fetching.gql)`
  query beautyStore($name: ID) {
    beautyStore(name: $name) {
      profile {
        contacts {
          type
          value
        }
        referralProgram {
          title
          greetingMessage
          message
          benefitsLink {
            relativeUrl
            title
          }
          allowedContacts
        }
      }
    }
  }
`;